import React from "react";

export default function AnalysisSummaryCard({ title, summary, metrics, tooltip }) {
  return (
    <div className="card p-4" title={tooltip}>
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      <p className="mt-2 text-sm text-slate-600">{summary}</p>
      <div className="mt-4 grid gap-3 md:grid-cols-2">
        {metrics.map((metric) => (
          <div key={metric.label} className="rounded-md border border-slate-100 p-3">
            <p className="text-xs text-slate-400">{metric.label}</p>
            <p className="mt-1 text-sm font-semibold text-slate-900">
              {metric.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
